import { langRouterLangMap } from '@/i18n/lang'
import { useTranslation } from 'react-i18next'
import { NavigateOptions, useNavigate, useParams, type To } from 'react-router-dom'

const useMeNavigate = () => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const urlParams = useParams()
  const routerLang = urlParams?.routerLang || langRouterLangMap[i18n.language]
  const customNavigate = (to: To, options?: NavigateOptions) => {
    let _copyTo = to
    if (!to.toString().includes(routerLang)) {
      _copyTo = `/${routerLang}${to}`
    }
    // 单独处理交易hash
    const transactionHashRegex = /^\/transactions\/[A-Fa-f0-9]{64}(?:\?.*)?$/
    if (transactionHashRegex.test(to.toString())) {
      // 在这里添加更多的自定义逻辑
      window.open(window.location.origin + _copyTo, '_blank')
    } else {
      // 调用原始的 navigate 方法
      navigate(_copyTo, options)
      window.scrollTo(0, 0)
    }
  }
  return customNavigate
}

export default useMeNavigate
